import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  useBlockMutation$data,
  type useBlockMutation as UseBlockMutation
} from '@/__generated__/useBlockMutation.graphql'

type CommitAsyncFn = (toUserId: string) => Promise<useBlockMutation$data>

export const useBlockMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isBlocking] = useMutation<UseBlockMutation>(graphql`
    mutation useBlockMutation($input: CreateBlockInput!) {
      createBlock(input: $input) {
        query {
          currentUserUnreadCount
          currentUser {
            ...MessagesView_user @arguments(after: null)
            ...LikesList_user @arguments(after: null)
          }
        }
      }
    }
  `)

  const block = useCallback<CommitAsyncFn>(
    (toUserId: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              block: {
                toUserId
              }
            }
          }
        })
      ),
    [commit]
  )

  return [block, isBlocking]
}
